import { getSignWall ,getSignlist} from '../../../../services/meetingManage/signWall';

const getInitState = () => ({});

export default {
  namespace: 'signWall',

  state: getInitState(),

  effects: {
    *fetchSignWall({ params }, { call }) {
      try {
        const response = yield call(getSignWall, params);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
    *fetchSignlist({ params }, { call }) {
      try {
        const response = yield call(getSignlist, params);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(String(e));
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    resetState() {
      return { ...getInitState() };
    },
  },
};
